import { useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";

import * as Push from "../helpers/push";
import { swissRefreshState } from "../states/common";

/**
 * Thông báo đẩy khi app ĐANG MỞ.
 *
 * Service worker chỉ chạy khi app đóng hoặc ở nền; app đang mở thì trình duyệt
 * không hiện gì cả. Không có khối này thì người đang mở Biadi là người duy nhất
 * không được báo - đúng những người đang ngồi chờ ở quán.
 *
 * Hiện bằng toast chứ không bằng Notification: một hộp thông báo của hệ điều
 * hành đè lên màn hình họ đang nhìn là phiền, mà bấm vào cũng chỉ dẫn tới đúng
 * trang đang mở.
 */
const PushForeground = () => {
  const navigate = useNavigate();
  /* Mọi thông báo ở đây đều nói "trạng thái trận vừa đổi", nên nhân tiện giục
     trang giải nạp lại - người dùng không phải tự kéo. */
  const nhoNapLai = useSetRecoilState(swissRefreshState);

  useEffect(() => {
    let huy: (() => void) | null = null;
    let conSong = true;

    Push.ngheKhiDangMo((tin) => {
      nhoNapLai((n) => n + 1);
      toast(
        (t) => (
          <span
            role="button"
            tabIndex={0}
            onClick={() => {
              toast.dismiss(t.id);
              navigate(tin.duongDan);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                toast.dismiss(t.id);
                navigate(tin.duongDan);
              }
            }}
            style={{ cursor: "pointer", display: "block" }}
          >
            <b>{tin.title}</b>
            {tin.body ? <div style={{ fontSize: 13, marginTop: 2 }}>{tin.body}</div> : null}
          </span>
        ),
        { duration: 7000, icon: "🔔" },
      );
    }).then((thoi) => {
      /* Hàm nghe dựng bất đồng bộ; component có thể đã biến mất trước khi nó
         xong, lúc đó phải huỷ ngay chứ không để nó treo lại. */
      if (conSong) {
        huy = thoi;
      } else {
        thoi();
      }
    });

    return () => {
      conSong = false;
      if (huy) {
        huy();
      }
    };
  }, [navigate, nhoNapLai]);

  return null;
};

export default PushForeground;
